import React from 'react';
import { Box, TextField, MenuItem, IconButton, Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { TransformationHeading } from './Heading';

export const MultiSourceColumns = ({
  sourceColumns,
  handleColumnChange,
  handleAddColumn,
  handleRemoveColumn,
  headers,
  disableForm,
  errors,
  minColumns = 2,
  maxColumns = 10,
}) => {
  console.log('error multi:', errors);
  return (
    <Box sx={{ mb: 1 }}>
      <TransformationHeading title="Source Columns *" disabled={disableForm} />
      {sourceColumns.map((col, index) => (
        <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
          <TextField
            select
            fullWidth
            value={col}
            onChange={(e) => handleColumnChange(index, e.target.value)}
            disabled={disableForm}
            size="small"
            error={!!errors?.[index]}
            helperText={errors?.[index] || `Column ${index + 1}`}
          >
            <MenuItem value="" disabled>
              Select column {index + 1}
            </MenuItem>
            {headers.map((header) => (
              <MenuItem key={header.label} value={header.label}>
                {header.label}
              </MenuItem>
            ))}
          </TextField>
          {sourceColumns.length > minColumns && (
            <IconButton
              onClick={() => handleRemoveColumn(index)}
              disabled={disableForm}
              size="small"
              sx={{ color: 'error.main' }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      ))}
      {sourceColumns.length < maxColumns && (
        <Button
          variant="outlined"
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleAddColumn}
          disabled={disableForm}
          size="small"
          sx={{ mt: 1 }}
        >
          Add Column
        </Button>
      )}
    </Box>
  );
};
